import { Component } from '@angular/core';

@Component({
  selector: 'app-consultation-request-header',
  templateUrl: './consultation-request-header.component.html',
  standalone: true,
})
export class ConsultationRequestHeaderComponent {}
